var map = {
	"./amex.png": "./src/assets/img/cards/amex.png",
	"./diners.png": "./src/assets/img/cards/diners.png",
	"./discover.png": "./src/assets/img/cards/discover.png",
	"./jcb.png": "./src/assets/img/cards/jcb.png",
	"./mastercard.png": "./src/assets/img/cards/mastercard.png",
	"./visa.png": "./src/assets/img/cards/visa.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/cards sync recursive ^\\.\\/.*\\.png$";